// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getServicesListStatus: { data: null },
  createServicesRequestStatus: { data: null },
  serviceRequestsUsersStatus: { data: null },
  getOnGoingServiceRequestsStatus: { data: null },
  updateServiceStatus: { data: null },
};
